import React, { ReactNode, useId } from "react";
import { PCheckboxStyle as S } from "./PCheckbox.style";
import { Checkbox, CheckboxProps } from "primereact/checkbox";

export type PCheckboxProps = CheckboxProps & {
  label?: ReactNode;
  labelClassName?: string;
};

export const PCheckbox = React.forwardRef<Checkbox, PCheckboxProps>((props, ref) => {
  const { labelClassName, ...cleanProps } = props;
  const genIds = useId();
  return props.label ? (
    <S.CheckboxWrapper className="flex align-items-center">
      <S.PCheckbox {...cleanProps} ref={ref} inputId={props.inputId || props.name || genIds} />
      <label
        onClick={(e) =>
          props.onChange &&
          props.onChange({
            target: e.target as never,
            value: !props.checked,
            stopPropagation: e.stopPropagation,
            preventDefault: e.preventDefault,
            checked: !!(e.target as never)["checked"],
            originalEvent: e,
          })
        }
        htmlFor={props.inputId || props.name || genIds}
        className={`ml-2 ${labelClassName || ""}`}
      >
        {props.label}
      </label>
    </S.CheckboxWrapper>
  ) : (
    <S.PCheckbox {...props} ref={ref} inputId={props.inputId || props.name || genIds} />
  );
});
